import { constants } from '../../../common/Localization';

// Create object of values whose friendly names should be looked up so that other values are not unintentionally mapped
export const friendlyValueNames: Record<string, any> = {
    awsRegion: {},
    onpremEnvironment: {},
    awsRightSizePolicy: {},
    awsEC2Tenancy: {},
    awsEC2PaymentTypes: {},
    awsEBSTypes: {},
    awsInitialBackup: {},
    awsSupportPlan: {},
    onPremServerBackup: {},
    onPremAdditionalRedundancy: {},
    onPremBackupDisk: {},
    onPrembackupIntialSnapshot: {},
    awsSANRedundancy: {},
    awsNASRedundancy: {},
    awsObjectRedundancy: {},
    projectDurationWeeks: {}
};

export const categories = createFormattedCategories();

export interface Category extends Record<string, any> {
    id: string;
    label: string;
    environment?: 'aws' | 'onPremises';
    childCategories: {
        aws?: string[];
        onPremises?: string[];
    } | string[];
    template?: string;
};

function createFormattedCategories() {
    // Format configuration category line items
    let formattedCategories: Category[] = [
        {
            id: 'tcoAssumptions',
            label: constants.GENERAL_ASSUMPTIONS,
            childCategories: ['tcoAssumptions'],
            template: 'categorySection'
        }
    ];

    const unassociatedEndOfListSections: Category[] = [
        {
            id: 'generalStorage',
            label: constants.GENERAL_STORAGE_ASSUMPTIONS,
            childCategories: ['generalStorage'],
            template: 'categorySection'
        }
    ];

    const categorySections: Category[] = [
        {
            id: 'discount',
            label: constants.DISCOUNT_ADJUSTMENT,
            childCategories: {
                onPremises: ['onPremDiscount']
            }
        }, {
            id: 'server',
            label: constants.SERVER_ESTIMATE,
            childCategories: {
                aws: [
                    'awsEC2Pricing',
                    'awsEC2RightSize'
                ],
                onPremises: [] // keep empty list here to include top-level labor estimate in comparison
            }
        }, {
            id: 'power',
            label: constants.POWER,
            childCategories: {
                onPremises: ['onPremPower']
            }
        }, {
            id: 'rackInfrastructure',
            label: constants.RACK_INFRA,
            childCategories: {
                onPremises: ['onPremITOperation']
            }
        }, {
            id: 'software',
            label: constants.SOFTWARE_AND_LICENSES,
            childCategories: {
                onPremises: ['onPremSoftware']
            }
        }, {
            id: 'storage',
            label: constants.STORAGE_ESTIMATE,
            childCategories: {
                aws: ['awsStorage'],
                onPremises: ['onPremStorage']
            }
        }, {
            id: 'network',
            label: constants.NETWORK_ESTIMATE,
            childCategories: {
                aws: ['awsNetwork'],
                onPremises: [
                    'onPremNetwork'
                ]
            }
        }, {
            id: 'labor',
            label: constants.IT_LABOR_ESTIMATE,
            childCategories: {
                aws: [], // keep empty list here to include top-level labor estimate in comparison
                onPremises: ['onPremAdmin']
            }
        }, {
            id: 'support',
            label: constants.SUPPORT_ESTIMATE,
            childCategories: {
                aws: ['awsLaborSupport']
            }
        }, {
            id: 'other',
            label: constants.OTHER_COSTS,
            childCategories: {
                aws: [],
                onPremises: []
            }
        }
    ];

    const hasChildCategoryType = (value: any): value is {aws?: string[]; onPremises?: string[];} => {
        return !Array.isArray(value);
    };

    categorySections.forEach(function (category) {
        if (hasChildCategoryType(category.childCategories) && category.childCategories.aws) {
            formattedCategories.push({
                environment: 'aws',
                id: category.id,
                label: `${constants.AWS} ${category.label}`,
                childCategories: category.childCategories.aws,
                template: 'categorySection'
            });
        }
    });

    categorySections.forEach(function (category) {
        if (hasChildCategoryType(category.childCategories) && category.childCategories.onPremises) {
            formattedCategories.push({
                environment: 'onPremises',
                id: category.id,
                label: `${constants.ON_PREMISES} ${category.label}`,
                childCategories: category.childCategories.onPremises,
                template: 'categorySection'
            });
        }
    });

    formattedCategories = formattedCategories.concat(unassociatedEndOfListSections);

    return formattedCategories;
}
